// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateOffersAppeal_paper__xtOb4 {
  position: relative;
  width: 460px;
  padding: 24px;
  background: #fff;
  border-radius: 28px !important;
  overflow-x: hidden;
}

.CreateOffersAppeal_image__4dwZP {
  display: block;
  margin: 0 auto;
}

.CreateOffersAppeal_close__f0C3Y {
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background: transparent;
  padding: 24px;
  transform: rotate(0deg);
  transition: 0.3s all;
  cursor: pointer;
}
.CreateOffersAppeal_close__f0C3Y:hover {
  transform: rotate(180deg);
}

.CreateOffersAppeal_title__XPlg4 {
  margin: 16px 0 0;
  font-size: 24px;
  font-weight: 400;
  color: #272A36;
}

.CreateOffersAppeal_descriptionItem__GUvmg {
  display: flex;
  margin-top: 24px;
  font-size: 16px;
  font-weight: 400;
  color: #272A36;
}
.CreateOffersAppeal_descriptionItem__GUvmg:last-of-type {
  margin-bottom: 8px;
}
.CreateOffersAppeal_descriptionItem__GUvmg svg {
  flex-shrink: 0;
  margin-right: 12px;
}

.CreateOffersAppeal_button__R5-Vg {
  width: 100%;
  margin-top: 16px;
  justify-content: flex-start;
}
.CreateOffersAppeal_button__R5-Vg svg {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/CreateOffersAppeal/CreateOffersAppeal.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;AACF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;AAFF;AAIE;EACE,iBAAA;AAFJ","sourcesContent":[".paper {\n  position: relative;\n  width: 460px;\n  padding: 24px;\n  background: #fff;\n  border-radius: 28px !important;\n  overflow-x: hidden;\n}\n\n.image {\n  display: block;\n  margin: 0 auto;\n}\n\n.close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 0;\n  background: transparent;\n  padding: 24px;\n  transform: rotate(0deg);\n  transition: 0.3s all;\n  cursor: pointer;\n\n  &:hover {\n    transform: rotate(180deg);\n  }\n}\n\n.title {\n  margin: 16px 0 0;\n  font-size: 24px;\n  font-weight: 400;\n  color: #272A36;\n}\n\n.descriptionItem {\n  display: flex;\n  margin-top: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  color: #272A36;\n\n  &:last-of-type {\n    margin-bottom: 8px;\n  }\n\n  svg {\n    flex-shrink: 0;\n    margin-right: 12px;\n  }\n}\n\n.button {\n  width: 100%;\n  margin-top: 16px;\n  justify-content: flex-start;\n\n  svg {\n    margin-right: 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `CreateOffersAppeal_paper__xtOb4`,
	"image": `CreateOffersAppeal_image__4dwZP`,
	"close": `CreateOffersAppeal_close__f0C3Y`,
	"title": `CreateOffersAppeal_title__XPlg4`,
	"descriptionItem": `CreateOffersAppeal_descriptionItem__GUvmg`,
	"button": `CreateOffersAppeal_button__R5-Vg`
};
export default ___CSS_LOADER_EXPORT___;
